import { useState, useEffect } from 'react';

export const useViewPlatform = () => {
  const [os, setOs] = useState<string>('unknown');

  useEffect(() => {
    const check = (agent) => {
      if (agent.indexOf('Windows') > 0) setOs('Windows');
      else if (agent.indexOf('Mac') > 0) setOs('Mac');
      else setOs('unknown');
    };
    check(navigator.userAgent);
  }, []);

  return os;
};
